import ReactRailsUJS from 'react_ujs'

import { viteConstructorRequireContext } from '../helpers/ViteHelper'
import baseFrontModules from '../helpers/entrypoint_modules/baseFront'

const roiContexts = import.meta.glob(
  ['~/independent_pages/tools/roi_calculator/**/*.{js,jsx,ts,tsx}'],
  { eager: true }
)
const contexts = Object.assign(roiContexts, baseFrontModules)

ReactRailsUJS.getConstructor = viteConstructorRequireContext(contexts)